import React, { useMemo } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// W-0779 — Seletor de Razões (disponíveis -> selecionadas), análogo ao #trazao do Delphi (Q-02=A).
// Fonte: UListaRazao.pas:447-615. Chave estável por item.codigo (LICOES §1.5 — nunca idx).
const toOption = (razao) => ({
  value: razao.codigo,
  label: `${razao.codigo} - ${razao.razao_social || '(sem razão social)'}`,
  razao,
});

const SeletorRazoes = ({ disponiveis, selecionadas, onChangeSelecionadas }) => {
  const opcoes = useMemo(() => disponiveis.map(toOption), [disponiveis]);
  const valorSelect = useMemo(() => selecionadas.map(toOption), [selecionadas]);

  const handleChange = (opcoesSelecionadas) => {
    const lista = Array.isArray(opcoesSelecionadas) ? opcoesSelecionadas : [];
    onChangeSelecionadas(lista.map((o) => o.razao));
  };

  const todasSelecionadas =
    disponiveis.length > 0 && selecionadas.length === disponiveis.length;

  const handleToggleTodas = () => {
    if (disponiveis.length === 0) return;
    onChangeSelecionadas(todasSelecionadas ? [] : [...disponiveis]);
  };

  return (
    <div>
      <Row className="mb-2">
        <Col xs={12}>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={handleToggleTodas}
            disabled={disponiveis.length === 0}
          >
            {todasSelecionadas
              ? `Desmarcar todas (${disponiveis.length})`
              : `Selecionar todas (${disponiveis.length})`}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Label className="small mb-1">
              Razões Selecionadas ({selecionadas.length})
            </Form.Label>
            <Select
              isMulti
              options={opcoes}
              value={valorSelect}
              onChange={handleChange}
              styles={customStyles}
              components={{ DropdownIndicator }}
              placeholder="Selecione as razões sociais..."
              noOptionsMessage={() => 'Nenhuma razão social disponível'}
              closeMenuOnSelect={false}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default SeletorRazoes;
